const formatQueryParams = (uri: string, params: string): string => {
  const qstring = uri.includes('?') ? `&${params}` : `?${params}`
  return uri + qstring
}

export default formatQueryParams
